import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API, timeout: 12000 });

export const postLocation = (data) => http.post("/location", data).then((r) => r.data);
export const getMembers = (code) => http.get(`/group/${encodeURIComponent(code)}/members`).then((r) => r.data);
export const setMeetPin = (data) => http.post("/meet", data).then((r) => r.data);
export const getMeetPin = (code) => http.get(`/group/${encodeURIComponent(code)}/meet`).then((r) => r.data);
export const respondMeet = (data) => http.post("/meet/respond", data).then((r) => r.data);
export const clearMeetPin = (code) => http.delete(`/group/${encodeURIComponent(code)}/meet`).then((r) => r.data);
export const sendPing = (data) => http.post("/ping", data).then((r) => r.data);
export const getPings = (code, userId) =>
  http.get(`/group/${encodeURIComponent(code)}/pings/${encodeURIComponent(userId)}`).then((r) => r.data);
